import React from 'react';
import { Box } from '@mui/system';
import { Step, StepButton, Stepper } from '@mui/material';

import { TypeOfUser, UmbrellaUserTypes } from '@pharmaplan/common';

import useProfessional from '../../../hooks/Professional/useProfessional';
import { pharmacistSteps, pharmacySteps, professionalSteps } from '../helper';

import classes from './styles';

interface ISignupStepper {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

const SignupStepper = ({ step, setStep }: ISignupStepper) => {
  const { selfUserType } = useProfessional();

  const stepConfig = {
    [TypeOfUser.pharmacy]: pharmacySteps(),
    [TypeOfUser.pharmacist]: pharmacistSteps(),
    [UmbrellaUserTypes.professional]: professionalSteps(),
  };

  const handleStep = (index: number) => {
    setStep(index);
  };

  return (
    <Box sx={classes.container}>
      <Stepper activeStep={step}>
        {Object.keys(stepConfig[selfUserType as keyof typeof stepConfig]).map((item, index) =>
          (
            <Step key={item}>
              <StepButton
                color="primary"
                onClick={() =>
                  handleStep(index)}
              >
                {stepConfig[selfUserType as keyof typeof stepConfig][item].label}
              </StepButton>
            </Step>
          ))}
      </Stepper>
    </Box>
  );
};

export default SignupStepper;
